import { FormHelperText, TextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import {
  DistrictField,
  ProvinceField,
  SubDistrictField,
  useAddress,
  ZipcodeField
} from "components/request-document/components/Address";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import JobSection from "components/request-document/components/JobSection";
import SpouseSection from "components/request-document/components/SpouseSection";
import { useExtendsionFormPartA } from "components/smart-visa-extension/useExtendsionForm";
import { EXTENSION_DOCUMENT_STEP } from "libs/configs/constant";
import {
  defaultChildren,
  getErrorMessage,
  isError,
  mapChildren
} from "libs/utils/form";
import { get } from "lodash-es";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";
import {
  selectCurrentSmartForm,
  selectCurrentSmartServiceId
} from "redux/modules/visaForm";

export default function PartA() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { formik, onSaveDraft } = useExtendsionFormPartA();
  const masterData = useSelector(selectMasterData);

  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const currentSmartForm = useSelector(selectCurrentSmartForm);
  const addressFieldOptions = useAddress({ formik });

  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const smartservice = get(masterData, "smartservice", []);
  const smartserviceReferId = get(
    currentSmartForm,
    "smartserviceReferId",
    null
  );
  const draftIdRef = get(currentSmartForm, "draftIdRef", null);

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <Steper isExtend currentStep={0} stepInfo={EXTENSION_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part A : Personal Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div>
                      <Typography>Full English name as in passport</Typography>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>First name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="personal.fistName"
                        value={formik.values.personal.fistName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.fistName", formik)}
                        helperText={getErrorMessage(
                          "personal.fistName",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Middle name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="personal.middleName"
                        value={formik.values.personal.middleName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.middleName", formik)}
                        helperText={getErrorMessage(
                          "personal.middleName",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Last name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="personal.lastName"
                        value={formik.values.personal.lastName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.lastName", formik)}
                        helperText={getErrorMessage(
                          "personal.lastName",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Current Nationality / Nationality at birth, if different
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        // style={{ width: 200 }}
                        error={isError("personal.nationalityID", formik)}
                      >
                        <InputLabel>Select your nationality</InputLabel>
                        <Select
                          label="Select your nationality"
                          name="personal.nationalityID"
                          value={formik.values.personal.nationalityID}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {nationalityConfig.map((nationality) => (
                            <MenuItem
                              value={nationality.nationalityID}
                              key={nationality.nationalityID}
                            >
                              {nationality.nationalityName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError("personal.nationalityID", formik)}
                        >
                          {getErrorMessage("personal.nationalityID", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>Date of birth ( dd-mm-yyyy )</InputLabel>
                      <DatePicker
                        // style={{ width: 200 }}
                        className={classes.formControl}
                        inputVariant="outlined"
                        disableFuture={false}
                        openTo="year"
                        format="DD-MM-YYYY"
                        label="Date of birth"
                        views={["year", "month", "date"]}
                        name={`personal.birthDate`}
                        value={
                          get(formik.values, `personal.birthDate`, null) || null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `personal.birthDate`,
                            date.format("YYYY-MM-DD")
                          );
                        }}
                        error={isError(`personal.birthDate`, formik)}
                        helperText={getErrorMessage(
                          `personal.birthDate`,
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Place of birth ( city, province/state, country )
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="personal.placeOfBirth"
                        value={formik.values.personal.placeOfBirth}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.placeOfBirth", formik)}
                        helperText={getErrorMessage(
                          "personal.placeOfBirth",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>Gender</InputLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              name="personal.gender"
                              value="M"
                              checked={formik.values.personal.gender === "M"}
                              onClick={() => {
                                formik.setFieldValue("personal.gender", "M");
                              }}
                            />
                          }
                          label="Male"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              name="personal.gender"
                              value="F"
                              checked={formik.values.personal.gender === "F"}
                              onClick={() => {
                                formik.setFieldValue("personal.gender", "F");
                              }}
                            />
                          }
                          label="Female"
                        />
                      </FormGroup>
                      <FormHelperText
                        error={isError("personal.gender", formik)}
                      >
                        {getErrorMessage("personal.gender", formik)}
                      </FormHelperText>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={4}>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>Marital status</InputLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              name="Single"
                              value="S"
                              checked={formik.values.document.Marittal === "S"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "S");
                              }}
                            />
                          }
                          label="Single"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              name="Married"
                              value="M"
                              checked={formik.values.document.Marittal === "M"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "M");
                              }}
                            />
                          }
                          label="Married"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              name="Divorced"
                              value="D"
                              checked={formik.values.document.Marittal === "D"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "D");
                              }}
                            />
                          }
                          label="Divorced"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              name="Windowed"
                              value="W"
                              checked={formik.values.document.Marittal === "W"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "W");
                              }}
                            />
                          }
                          label="Windowed"
                        />
                      </FormGroup>
                      <FormHelperText
                        error={isError("document.Marittal", formik)}
                      >
                        {getErrorMessage("document.Marittal", formik)}
                      </FormHelperText>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>Passport number</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="personal.passportNumber"
                        value={formik.values.personal.passportNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.passportNumber", formik)}
                        helperText={getErrorMessage(
                          "personal.passportNumber",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={8} />
                    <div className={classes.wrapField}>
                      <InputLabel>Date of issue ( dd-mm-yyyy )</InputLabel>
                      <DatePicker
                        // style={{ width: 200 }}
                        className={classes.formControl}
                        inputVariant="outlined"
                        disableFuture={false}
                        openTo="year"
                        format="DD-MM-YYYY"
                        label="Date of issue"
                        views={["year", "month", "date"]}
                        name={`personal.dateofIssue`}
                        value={
                          get(formik.values, `personal.dateofIssue`, null) ||
                          null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `personal.dateofIssue`,
                            date.format("YYYY-MM-DD")
                          );
                        }}
                        error={isError(`personal.dateofIssue`, formik)}
                        helperText={getErrorMessage(
                          `personal.dateofIssue`,
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={9} />
                    <div className={classes.wrapField}>
                      <InputLabel>Valid until ( dd-mm-yyyy )</InputLabel>
                      <DatePicker
                        className={classes.formControl}
                        // style={{ width: 200 }}
                        inputVariant="outlined"
                        disableFuture={false}
                        openTo="year"
                        format="DD-MM-YYYY"
                        label="Valid until"
                        views={["year", "month", "date"]}
                        name={`personal.validuntil`}
                        value={
                          get(formik.values, `personal.validuntil`, null) ||
                          null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `personal.validuntil`,
                            date.format("YYYY-MM-DD")
                          );
                        }}
                        error={isError(`personal.validuntil`, formik)}
                        helperText={getErrorMessage(
                          `personal.validuntil`,
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={10} />
                    <div className={classes.wrapField}>
                      <FormGroup row style={{ marginTop: -10 }}>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              name="document.HasAddressInThai"
                              checked={formik.values.document.HasAddressInThai}
                              onClick={() => {
                                const HasAddressInThai =
                                  !formik.values.document.HasAddressInThai;

                                formik.setFieldValue(
                                  "document.HasAddressInThai",
                                  HasAddressInThai
                                );

                                if (!HasAddressInThai) {
                                  formik.setFieldValue(
                                    "document.AddressInThai",
                                    ""
                                  );
                                }
                              }}
                            />
                          }
                          label="Current address in Thailand"
                        />
                      </FormGroup>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="document.AddressInThai"
                        value={formik.values.document.AddressInThai}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={!formik.values.document.HasAddressInThai}
                        error={isError("document.AddressInThai", formik)}
                        helperText={getErrorMessage(
                          "document.AddressInThai",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              {/* <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Address</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="document.Address"
                        value={formik.values.document.Address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.Address", formik)}
                        helperText={getErrorMessage("document.Address", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow> */}

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <ProvinceField showBadge {...addressFieldOptions} />
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <DistrictField showBadge {...addressFieldOptions} />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <SubDistrictField showBadge {...addressFieldOptions} />
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <ZipcodeField showBadge {...addressFieldOptions} />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={11} />
                    <div className={classes.wrapField}>
                      <InputLabel>Home / mobile phone number</InputLabel>
                      <TextField
                        variant="outlined"
                        // type="number"
                        className={classes.textField}
                        name="document.PhoneNumber"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.document.PhoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.PhoneNumber", formik)}
                        helperText={getErrorMessage(
                          "document.PhoneNumber",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={12} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="document.Email"
                        value={formik.values.document.Email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.Email", formik)}
                        helperText={getErrorMessage("document.Email", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <SpouseSection
                defaultChildren={mapChildren(defaultChildren)}
                formik={formik}
                bagdeStart={13}
                colSpan={6}
              />

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={15} />
                    <div className={classes.wrapField}>
                      <InputLabel>Current Visa</InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("document.Smart", formik)}
                      >
                        <InputLabel>Current Visa</InputLabel>
                        <Select
                          label="Current Visa"
                          name="document.Smart"
                          disabled
                          value={
                            draftIdRef ? smartserviceReferId : smartServiceId
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {smartservice.map((service) => (
                            <MenuItem
                              value={service.smartserviceId}
                              key={service.smartserviceId}
                            >
                              {service.smartserviceName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError("document.Smart", formik)}
                        >
                          {getErrorMessage("document.Smart", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={16} />
                    <div className={classes.wrapField}>
                      <InputLabel>Valid until ( dd-mm-yyyy )</InputLabel>
                      <DatePicker
                        className={classes.formControl}
                        inputVariant="outlined"
                        disableFuture={false}
                        openTo="year"
                        format="DD-MM-YYYY"
                        label="Valid until"
                        views={["year", "month", "date"]}
                        name={`document.validuntil`}
                        value={
                          get(formik.values, `document.validuntil`, null) ||
                          null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `document.validuntil`,
                            date.format("YYYY-MM-DD")
                          );
                        }}
                        error={isError(`document.validuntil`, formik)}
                        helperText={getErrorMessage(
                          `document.validuntil`,
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <JobSection
                formik={formik}
                colSpan={6}
                bagdeStart={17}
                prefixFieldName="document"
              />

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={20} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Name of contact person in Thailand
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="document.ContactPersonInThai"
                        value={formik.values.document.ContactPersonInThai}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.ContactPersonInThai", formik)}
                        helperText={getErrorMessage(
                          "document.ContactPersonInThai",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Relationship with the applicant</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="document.ContactRelationship"
                        value={formik.values.document.ContactRelationship}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.ContactRelationship", formik)}
                        helperText={getErrorMessage(
                          "document.ContactRelationship",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={21} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="document.ContactEmail"
                        value={formik.values.document.ContactEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.ContactEmail", formik)}
                        helperText={getErrorMessage(
                          "document.ContactEmail",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Mobile phone number</InputLabel>
                      <TextField
                        // type="number"
                        variant="outlined"
                        className={classes.textField}
                        name="document.ContactMobile"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.document.ContactMobile}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.ContactMobile", formik)}
                        helperText={getErrorMessage(
                          "document.ContactMobile",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "21px 35px",
          }}
        >
          <InputLabel>
            *Spouse and children wishing to apply for Smart Visa must submit
            their own application separately.
          </InputLabel>
        </div>

        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
